import { Card, CardContent, Checkbox, FormControlLabel, Grid } from "@mui/material";
import { useBarringList } from "./hook/useBarringList";
import { EBARRING_STATUS } from "./interface/IBarrings";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";

export const BarringList = () => {
    const {
        getBarringListState: { error, isLoading },
        barringList,
        getBarringList,
    } = useBarringList();

    return (
        <Card elevation={2}>
            <CardContent>
                <HandleErrorAndLoading error={error} isLoading={isLoading} retryFetch={getBarringList}>
                    <Grid container justifyContent="center" spacing={2}>
                        {barringList.map(({ barringStatus, name, barringCode }) => (
                            <Grid item key={barringCode} xs={12}>
                                <FormControlLabel
                                    checked={barringStatus === EBARRING_STATUS.ACTIVE}
                                    control={<Checkbox />}
                                    disabled
                                    label={name}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </HandleErrorAndLoading>
            </CardContent>
        </Card>
    );
};
